/**
 * 设备类型判断
 */
function detectDeviceType() {
  const ua = navigator.userAgent;

  // Phone（性能 & 内存最受限）
  const isPhone =
    /iPhone|iPod|Android.*Mobile|Windows Phone/i.test(ua);

  // iPad / Tablet
  // iPadOS 13+ 会伪装成 Macintosh
  const isPad =
    /iPad/.test(ua) ||
    (ua.includes('Macintosh') && navigator.maxTouchPoints > 1);

  const isDesktop = !isPhone && !isPad;

  return {
    isPhone,
    isPad,
    isDesktop,
  };
}


/**
 * 处理富文本内容，移除HTML标签并清理空格
 * @param {string} raw 原始富文本内容
 * @returns {string} 处理后的文本内容
 */
function sanitizeRichText(raw) {
  if (!raw) return '';
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(String(raw), 'text/html');
    const text = (doc.body && doc.body.textContent) ? doc.body.textContent : String(raw);
    return text.replace(/\s+/g, ' ').trim();
  } catch (e) {
    const tmp = document.createElement('div');
    tmp.innerHTML = String(raw);
    const text = tmp.textContent || tmp.innerText || '';
    return text.replace(/\s+/g, ' ').trim();
  }
}




/**
 * 计算字符串的 SHA-256 哈希值并返回十六进制字符串
 * @param {string} str 输入字符串
 * @returns {Promise<string>} SHA-256 哈希值的十六进制字符串
 */
async function sha256Hex(str) {
    const buf = new TextEncoder().encode(str);
    const hash = await crypto.subtle.digest('SHA-256', buf);
    return Array.from(new Uint8Array(hash))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}
/**
 * 获取当前环境的设备信息
 * @returns {Object} 包含 UA、语言、时区、屏幕分辨率、CPU 核心数、内存信息的对象
 */
function getEnvInfo() {
    return {
        ua: navigator.userAgent,
        lang: navigator.language,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        // screen: `${screen.width}x${screen.height}`,
        cores: navigator.hardwareConcurrency || '',
        memory: navigator.deviceMemory || ''
    };
}
/**
 * 获取当前设备的唯一指纹
 * @returns {Promise<string>} 设备指纹的 SHA-256 哈希值
 */
async function getDeviceFingerprint() {
    const env = getEnvInfo();
    const envStr = Object.keys(env).sort().map(k => `${k}:${env[k]}`).join('|');
    return await sha256Hex(envStr);
}




/*
* 处理目标ID，替换模板前缀
* @param {string} rawTargetId 原始目标ID
* @param {string} [sectionId] 当前section.id (可选，如果提供则提取前缀)
* @returns {string} 处理后的目标ID
*/ 
function resolveTargetId(rawTargetId, sectionId) {
  if (!rawTargetId) return rawTargetId;
  
  if (sectionId) {
    // 模拟 {{ section.id | split: "__" | first }} 的逻辑
    const firstPart = sectionId.split('__')[0];
    const templatePrefix = 'shopify-section-' + firstPart;
    return rawTargetId.replace(/shopify-section-template--\d+/, templatePrefix);
  }
  
  return rawTargetId;
}